import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const swoop = new URL('../../public/swoop.png', import.meta.url).href;

const FOOTER_OPTIONS = [
  'Terms and Conditions',
  'Privacy Policy',
  'Cookie Preferences',
  'Contact Us',
];

export default function Footer() {
  const theme = useTheme();
  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: `${theme.palette.primary.main}`,
        maskImage: `linear-gradient(to bottom, transparent 0px, black 15px)`,
        height: '20vh',
        display: 'flex',
        justifyContent: 'center',
        backgroundImage: `url(${swoop})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
      }}
    >
      <Box
        component='ul'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '45px',
          listStyle: 'none',
          paddingTop: '30px',
          paddingBottom: '50px',
        }}
      >
        {FOOTER_OPTIONS.map((element, idx) => (
          <Box
            component='li'
            key={idx}
            onClick={() => {
              // todo -> pop up modal with text content for each footer option
              console.log(`Footer option: ${element} clicked!`);
            }}
          >
            <Typography
              sx={{
                color: 'white',
                fontSize: '22px',
                '&:hover': {
                  cursor: 'pointer',
                  textDecoration: 'underline',
                },
              }}
            >
              {element}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
